/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { videoFormats } from "../../constants/commons";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import playIcon from "../../assets/play.svg";

interface VideoProps {
  mediaFileName?: string;
  videoUrl?: string;
}

export const Video: React.FunctionComponent<VideoProps> = (props) => {
  const { mediaFileName, videoUrl } = props;
  const isMobile = useIsMobile();
  const isTablet = useIsTab();
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [playButtonClicked, setPlayButtonClicked] = React.useState<boolean>(
    false
  );

  const playVideo = () => {
    if (videoRef.current) {
      setPlayButtonClicked(true);
      videoRef.current.play();
      videoRef.current.controls = true;
    }
  };

  return (
    <React.Fragment>
      <video ref={videoRef} loop={true} controls={false}>
        <source
          src={videoUrl || require(`../../assets/videos/${mediaFileName}`)}
          type={videoFormats.mp4}
        />
      </video>
      {!playButtonClicked &&
        (isMobile || isTablet ? (
          <button onClick={playVideo} className="video-button">
            <img src={playIcon} alt="" />
          </button>
        ) : (
          <button onClick={playVideo} className="video-button">
            <img src={playIcon} alt="" /> PLAY VIDEO
          </button>
        ))}
    </React.Fragment>
  );
};
